module.exports = __webpack_public_path__ + "03395c7ceb1fe370be7f15a0177993e6.png";